export default "__VITE_ASSET__d3a50d2c__"